import { useState, useEffect } from 'react'
import clsx from 'clsx'
import numberFormat from '@/utils/numberFormat'
import './MemberTierPopup.css'

const ANIMATION_TIME = 200

const format = data => numberFormat(data, { formatKey: 'max2', compact: true })

export default function MemberTierPopup({
  show,
  hidePopupCallback = () => {},
  feeProgramMaxTier,
  feeProgramInfoMap
}) {
  const [showElement, setShowElement] = useState(false)
  const [active, setActive] = useState(false)

  useEffect(() => {
    if (show) {
      setShowElement(true)
      setTimeout(() => setActive(true), 20)
    }
  }, [show])

  const onPopupClose = () => {
    setActive(false)
    setTimeout(() => {
      setShowElement(false)
      hidePopupCallback()
    }, ANIMATION_TIME)
  }

  const MemberTierList = []

  if (Object.keys(feeProgramInfoMap).length > 0) {
    for (let i = 1; i <= feeProgramMaxTier; i++) {
      const { tier, volume_min, volume_max, maker_fee, taker_fee } =
        feeProgramInfoMap[i] || {}
      MemberTierList.push(
        <tr key={tier} className="table-list-row">
          <td className="table-list-cell align-left">{tier}</td>
          <td className="table-list-cell align-left">
            {volume_max
              ? `${format(volume_min)} - ${format(volume_max)}`
              : `Above ${format(volume_min)}`}
          </td>
          <td className="table-list-cell align-right">{maker_fee} %</td>
          <td className="table-list-cell align-right">{taker_fee} %</td>
        </tr>
      )
    }
  }

  return (
    <div
      className={clsx('popup-card-overlay', {
        show: showElement,
        active
      })}
    >
      <div className="popup-card member-tier-popup">
        <div className="member-tier-popup-title">Member Tier</div>
        <table className="table-list">
          <thead>
            <tr className="table-list-header">
              <th className="table-list-cell align-left">Tier</th>
              <th className="table-list-cell align-left">
                30 Day Volume (USDC)
              </th>
              <th className="table-list-cell align-right">Maker Fee</th>
              <th className="table-list-cell align-right">Taker Fee</th>
            </tr>
          </thead>
          <tbody>{MemberTierList}</tbody>
        </table>
        <div className="popup-card-close-button" onClick={onPopupClose} />
      </div>
    </div>
  )
}
